
var accordions = document.querySelectorAll('.accordion');


accordions.forEach(function(accordion) {


	var accordion_rows = accordion.querySelectorAll('li');

	accordion_rows.forEach(function(row) {
		var trigger = row.querySelector('.accordion__toggle--chart'); 

		var toggleChart = row.querySelector('.accordion__toggle--graph');
		var toggleTable = row.querySelector('.accordion__toggle--table');

		toggleTable.addEventListener('click', function(event) {
			row.classList.remove('show--chart');
			row.classList.add('show--table');
		});

		toggleChart.addEventListener('click', function(event) {
			row.classList.remove('show--table');
			row.classList.add('show--chart');
		});


		trigger.addEventListener('click', function(event) {
			event.preventDefault();

			accordion_rows.forEach(function(row) {
		    row.classList.remove('active');
		    row.querySelector('.inner').classList.remove('show')
			});

		  if (row.classList.contains('active')) {
		    row.classList.remove('active');
		    row.classList.remove('active');
		    row.querySelector('.inner').classList.add('show')
		  } else {
		    row.classList.add('active');
		    row.querySelector('.inner').classList.remove('show')
		  }
		});



	});
	

})

